import * as moment from 'moment'; // Figure out something, we use convertToUtc on date object:(
import 'cordova-plugin-purchase';
import SUBSCRIPTION from '@powerednow/shared/constants/subscription';
import {
    PurchasePluginBridge,
    IPoweredNowPurchaseRecord,
    EnrichedStoreProduct,
    IPoweredNowConsmuptionExtraRecord,
} from './PurchasePluginBridge';

declare let Ext: any;
declare let Date: any;

export interface IAppleTransaction extends CdvPurchase.Transaction {
    expires_date: string;
    expires_date_ms: string;
    expires_date_pst: string;
    id: string;
    is_in_intro_offer_period: string;
    is_trial_period: string;
    original_purchase_date: string;
    original_purchase_date_ms: string;
    original_purchase_date_pst: string;
    original_transaction_id: string;
    product_id: string;
    purchase_date: string;
    purchase_date_ms: string;
    purchase_date_pst: string;
    quantity: string;
    subscription_group_identifier: string; 
    transaction_id: string;
    web_order_line_item_id: string;
}

export interface IAppleProduct extends CdvPurchase.Product {
    transaction: IAppleTransaction;
}

export default class PurchasePluginBridgeIos extends PurchasePluginBridge {
    protected static get platform() { return window?.CdvPurchase?.Platform?.APPLE_APPSTORE; }

    protected hasExistingPurchaseRecordForTransaction(transaction: CdvPurchase.Transaction) {
        if (transaction) {
            const purchasesStore = Ext.getStore('Purchases');
            const existingPurchaseRecord = purchasesStore.findRecordByFilterFn((purchaseRecord: IPoweredNowPurchaseRecord) => [purchaseRecord.transaction_id, purchaseRecord.transactionid, purchaseRecord.original_transaction_id].includes(transaction.transactionId));

            return Boolean(existingPurchaseRecord);
        }
        return false;
    }

    protected getPoweredNowPurchaseRecord(verifiedReceipt: CdvPurchase.VerifiedReceipt): IPoweredNowPurchaseRecord | null {
        const lastTransaction = verifiedReceipt.sourceReceipt.lastTransaction();
        const product = this.store.get(lastTransaction.products[0].id); // This is not the best, but I don't know how we can end up having multiple products in the same transaction
        const enrichedStoreProduct = PurchasePluginBridge.enrichProductData(product);
        const rawTransaction:CdvPurchase.AppleAppStore.VerifyReceipt.AppleTransaction = verifiedReceipt.raw.transaction as unknown as CdvPurchase.AppleAppStore.VerifyReceipt.AppleTransaction;
        /**
         * Extra safety. We can't do anything if an ios subscription doesn't have expiration date. Most likely an invalid/fakse subscription, lets do nothing.
         */
        if (!rawTransaction.expires_date_ms) {
            return null;
        }

        /**
         * Sorry, I gave up typing this, absolutely ad-hoc, some properties appear, some are missing, base typing are unreliable.
         * Maybe because it is private or idk, but the data it returns is also unusable.
         */
        // @ts-ignore
        if (!lastTransaction.appStoreReceipt) {
            // @ts-ignore
            lastTransaction.appStoreReceipt = lastTransaction?.parentReceipt?.nativeData?.appStoreReceipt;
        }
        return {
            dt_created: Ext.Date.format(new Date().convertToUTC(), 'Y-m-d H:i:s'),
            product: enrichedStoreProduct.id,
            transactionid: lastTransaction.transactionId,
            receipt: JSON.stringify(lastTransaction),
            order_id: rawTransaction.web_order_line_item_id,
            quantity: Number(rawTransaction.quantity),
            original_transaction_id: rawTransaction.original_transaction_id,
            transaction_id: lastTransaction.transactionId,
            expires_date: Ext.Date.format(new Date(+rawTransaction.expires_date_ms).convertToUTC(), 'Y-m-d H:i:s'),
            purchase_date: Ext.Date.format(new Date(+rawTransaction.purchase_date_ms).convertToUTC(), 'Y-m-d H:i:s'),
            original_purchase_date: Ext.Date.format(new Date(+rawTransaction.original_purchase_date_ms).convertToUTC(), 'Y-m-d H:i:s'),
            purchase_origin: SUBSCRIPTION.PURCHASE_ORIGIN_ID.ITUNES,
            purchase_currency: enrichedStoreProduct.currency,
            purchase_amount: enrichedStoreProduct.priceDecimal,
            original_price: String(enrichedStoreProduct.priceDecimal),
        };
    }

    protected getPoweredNowConsumptionExtraRecord(verifiedReceipt: CdvPurchase.VerifiedReceipt): IPoweredNowConsmuptionExtraRecord {
        const lastTransaction = verifiedReceipt.sourceReceipt.lastTransaction();
        const product = this.store.get(lastTransaction.products[0].id); // This is not the best, but I don't know how we can end up having multiple products in the same transaction
        const rawTransaction:CdvPurchase.AppleAppStore.VerifyReceipt.AppleTransaction = verifiedReceipt.raw.transaction as unknown as CdvPurchase.AppleAppStore.VerifyReceipt.AppleTransaction;

        const purchaseSetup = this.getPurchaseSetupRecordForProduct(product);
        const enrichedStoreProduct = PurchasePluginBridge.enrichProductData(product);
        const purchaseDate = moment.utc(+lastTransaction.purchaseDate);
        const daysBeforeExpire = purchaseSetup.data.days_before_expires;
        const expiryDate = moment.utc(purchaseDate).add(daysBeforeExpire, 'day');
        const type = this.getConsumptionExtraType(product);
        return {
            type,
            product: enrichedStoreProduct.product_id,
            count: purchaseSetup.data[type],
            quantity: Number(rawTransaction.quantity),
            dt_created: purchaseDate.format('YYYY-MM-DD HH:mm:ss'),
            purchase_date: purchaseDate.format('YYYY-MM-DD HH:mm:ss'),
            expires_date: expiryDate.format('YYYY-MM-DD HH:mm:ss'),
            isverified: 0,
            order_id: rawTransaction.web_order_line_item_id,
            original_price: String(enrichedStoreProduct.priceDecimal),
            receipt: JSON.stringify(rawTransaction),
            transaction_id: lastTransaction.transactionId,
            purchase_origin: SUBSCRIPTION.PURCHASE_ORIGIN_ID.ITUNES,
            purchase_currency: enrichedStoreProduct.currency,
            purchase_amount: enrichedStoreProduct.priceDecimal,
        };
    }
}
